import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const SubsidyDocumentsTable = ({
  documentsData = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/client-subsidy-documents/${id}`);
  };

  const returnClassname = (isApplyforAIF) => {
    return isApplyforAIF ? "badge bg-orange me-2" : "";
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            <th>Sr.</th>
            <th>Client Name</th>
            <th>aadhar Fr.</th>
            <th>aadhar Ba.</th>
            <th>pan</th>
            <th>workOrder</th>
            <th>cibil</th>
            <th>ITR</th>
            <th>cast Cert.</th>
            <th>farmer Cert.</th>
            <th>Rental Doc.</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {documentsData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            let isApplyforAIF = item?.appliedForAIF;
            return (
              <tr key={index}>
                <td>{Index}</td>
                <td>
                  <span className={returnClassname(isApplyforAIF)}></span>
                  {item?.clientProject?.clientName}
                </td>
                <td>
                  {item?.aadharcardPhotoFront ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.aadharcardPhotoBack ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.pancardPhoto ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.workOrder ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.cibilReport ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.ITRReport ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.castCertificate ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.farmerCertificate ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  {item?.rentalDocuments ? (
                    <FaCheckCircle fontSize={"20px"} color="#34A853" />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SubsidyDocumentsTable;
